import { Component, OnInit } from "@angular/core";
import { AngularFireAnalytics } from "@angular/fire/compat/analytics";
import { MatDialogRef } from "@angular/material/dialog";
import { AuthService } from "@core/auth.service";
import { IonicModule } from "@ionic/angular";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
  selector: "app-syndicate-member-popup",
  templateUrl: "./syndicate-member-popup.component.html",
  styleUrls: ["./syndicate-member-popup.component.scss"],
  standalone: true,
  imports: [IonicModule, TranslatePipe],
})
export class SyndicateMemberPopupComponent implements OnInit {
  public userId: string;
  constructor(public dialogRef: MatDialogRef<SyndicateMemberPopupComponent>, private analytics: AngularFireAnalytics, private authService: AuthService) {
  }

  async ngOnInit() {
    await this.authService.getUid("SyndicateMemberPopupComponent").then((uid) => {
      this.userId = uid;
    })
    this.analytics.logEvent("syndicate_member_modal", { userId: this.userId });
  }

  inviteMember() {
    this.dialogRef.close();
  }

  close() {
    this.dialogRef.close();
  }
}
